export default __webpack_public_path__ + "static/media/sketch_girl.2ef61079.jpg";